/**
 * Logo Carousel - Splide with AutoScroll.
 * Supports multi-row layout moving in opposite directions.
 */

import '@splidejs/splide/css';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export const initLogoCarousel = () => {
	const sections = document.querySelectorAll('.logo-carousel-section');
	if (!sections.length) return;

	sections.forEach((section) => {
		const sliders = section.querySelectorAll('.lcs-logo-slider');
		sliders.forEach((slider, index) => {
			if (slider.dataset.splideInit) return;
			slider.dataset.splideInit = 'true';

			const direction = slider.dataset.direction || (index % 2 === 1 ? 'rtl' : 'ltr');

			const splide = new Splide(slider, {
				type: 'loop',
				drag: 'free',
				focus: 'center',
				arrows: false,
				pagination: false,
				autoWidth: true,
				gap: '3rem',
				direction: direction,
				autoScroll: {
					speed: 0.8,
					pauseOnHover: false,
					pauseOnFocus: false,
				},
				breakpoints: {
					767: {
						gap: '20px',
					},
				},
			});

			splide.mount({ AutoScroll });
		});
	});
};

// Self-initialise on DOMContentLoaded or immediately if DOM is already ready.
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initLogoCarousel);
} else {
	initLogoCarousel();
}

// ACF Gutenberg Preview hook.
if (typeof window !== 'undefined' && window.acf) {
	window.acf.addAction('render_block_preview/type=logo-carousel', () => {
		const sections = document.querySelectorAll('.logo-carousel-section');
		sections.forEach((section) => {
			const sliders = section.querySelectorAll('.lcs-logo-slider');
			sliders.forEach((slider) => {
				delete slider.dataset.splideInit;
			});
		});
		initLogoCarousel();
	});
}

export default initLogoCarousel;